module.exports = function (Konva) {
    'use strict';
    function createSegmentMarker(options) {
        var handleHeight = 20;
        var handleWidth = handleHeight / 2;
        var handleY = options.height / 2 - 10.5;
        var handleX = -(handleWidth / 2) + 0.5;
        var group = new Konva.Group({
            draggable: options.draggable,
            dragBoundFunc: function (pos) {
                var limit;
                if (options.inMarker) {
                    limit = options.segmentGroup.outMarker.getX() - options.segmentGroup.outMarker.getWidth();
                    if (pos.x > limit) {
                        pos.x = limit;
                    }
                } else {
                    limit = options.segmentGroup.inMarker.getX() + options.segmentGroup.inMarker.getWidth();
                    if (pos.x < limit) {
                        pos.x = limit;
                    }
                }
                return {
                    x: pos.x,
                    y: this.getAbsolutePosition().y
                };
            }
        });
        var xPosition = options.inMarker ? -24 : 24;
        var text = new Konva.Text({
            x: xPosition,
            y: options.height / 2 - 5,
            text: '',
            fontSize: 10,
            fontFamily: 'sans-serif',
            fill: '#000',
            textAlign: 'center'
        });
        text.hide();
        group.label = text;
        var handle = new Konva.Rect({
            x: handleX,
            y: handleY,
            width: handleWidth,
            height: handleHeight,
            fill: options.color,
            stroke: options.color,
            strokeWidth: 1
        });
        var line = new Konva.Line({
            x: 0,
            y: 0,
            points: [
                0.5,
                0,
                0.5,
                options.height
            ],
            stroke: options.color,
            strokeWidth: 1
        });
        if (options.draggable && options.onDrag) {
            group.on('dragmove', function () {
                options.onDrag(options.segmentGroup, options.segment, options.inMarker);
            });
            group.on('dragstart', function () {
                if (options.inMarker) {
                    text.setX(xPosition - text.getWidth());
                }
                options.onDragStart(options.segment, options.inMarker);
                text.show();
                options.layer.draw();
            });
            group.on('dragend', function () {
                options.onDragEnd(options.segment, options.inMarker);
                text.hide();
                options.layer.draw();
            });
        }
        handle.on('mouseover touchstart', function () {
            if (options.inMarker) {
                text.setX(xPosition - text.getWidth());
            }
            text.show();
            options.layer.draw();
        });
        handle.on('mouseout touchend', function () {
            text.hide();
            options.layer.draw();
        });
        group.add(text);
        group.add(line);
        group.add(handle);
        return group;
    }
    function createSegmentLabel(segmentGroup, segment) {
        return new Konva.Text({
            x: 12,
            y: 12,
            text: segment.labelText,
            textAlign: 'center',
            fontSize: 12,
            fontFamily: 'Arial, sans-serif',
            fill: '#000'
        });
    }
    function createPointMarker(options) {
        var handleTop = options.height / 2 - 10.5;
        var handleWidth = 10;
        var handleHeight = 20;
        var handleX = -(handleWidth / 2) + 0.5;
        var group = new Konva.Group({
            draggable: options.draggable,
            dragBoundFunc: function (pos) {
                return {
                    x: pos.x,
                    y: this.getAbsolutePosition().y
                };
            }
        });
        if (options.onDragStart) {
            group.on('dragstart', function () {
                options.onDragStart(options.point);
            });
        }
        if (options.onDragMove) {
            group.on('dragmove', function () {
                options.onDragMove(options.point);
            });
        }
        if (options.onDragEnd) {
            group.on('dragend', function () {
                options.onDragEnd(options.point);
            });
        }
        if (options.onDblClick) {
            group.on('dblclick', function () {
                options.onDblClick(options.point);
            });
        }
        if (options.onMouseEnter) {
            group.on('mouseenter', function () {
                options.onMouseEnter(options.point);
            });
        }
        if (options.onMouseLeave) {
            group.on('mouseleave', function () {
                options.onMouseLeave(options.point);
            });
        }
        var text = null;
        if (options.showLabel) {
            text = new Konva.Text({
                x: 2,
                y: 12,
                text: options.point.labelText,
                textAlign: 'left',
                fontSize: 10,
                fontFamily: 'sans-serif',
                fill: '#000'
            });
            group.label = text;
        }
        var handle = null;
        if (options.draggable) {
            handle = new Konva.Rect({
                x: handleX,
                y: handleTop,
                width: handleWidth,
                height: handleHeight,
                fill: options.handleColor
            });
        }
        var line = new Konva.Line({
            x: 0,
            y: 0,
            points: [
                0,
                0,
                0,
                options.height
            ],
            stroke: options.handleColor,
            strokeWidth: 1
        });
        var time = null;
        if (handle) {
            time = new Konva.Text({
                x: -24,
                y: options.height / 2 - 5,
                text: '',
                fontSize: 10,
                fontFamily: 'sans-serif',
                fill: '#000',
                textAlign: 'center'
            });
            time.hide();
            group.time = time;
            handle.on('mouseover touchstart', function () {
                time.setX(-24 - time.getWidth());
                time.show();
                options.layer.draw();
            });
            handle.on('mouseout touchend', function () {
                time.hide();
                options.layer.draw();
            });
            group.on('dragstart', function () {
                time.setX(-24 - time.getWidth());
                time.show();
                options.layer.draw();
            });
            group.on('dragend', function () {
                time.hide();
                options.layer.draw();
            });
        }
        if (handle) {
            group.add(handle);
        }
        group.add(line);
        if (text) {
            group.add(text);
        }
        if (time) {
            group.add(time);
        }
        return group;
    }
    return {
        createSegmentMarker: createSegmentMarker,
        createPointMarker: createPointMarker,
        createSegmentLabel: createSegmentLabel
    };
}(require('konva'));